import React from 'react';
import { IconCategoryValue as IconCategoryValue$2 } from './component.js';
import { IconCategoryValue as IconCategoryValue$1 } from './component.legacy.js';

var IconCategoryValue = function IconCategoryValue(props) {
  var _props$renderAsLegacy = props.renderAsLegacy,
      renderAsLegacy = _props$renderAsLegacy === void 0 ? true : _props$renderAsLegacy;

  if (renderAsLegacy || props.chakra && props.chakra === 'off') {
    return /*#__PURE__*/React.createElement(IconCategoryValue$1, props);
  }

  return /*#__PURE__*/React.createElement(IconCategoryValue$2, props);
};

IconCategoryValue.displayName = "IconCategoryValue";
export { IconCategoryValue };